import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as listingActions from '../actions/listings';
import * as searchActions from '../actions/search';
import ListingCard from '../components/listingCard';
import ListViewTable from '../components/listViewTable';
import ListingModal from '../components/listingModal';
import ListingDetailsModal from '../components/listingDetailsModal';
import MySearches, { SavedSearchModal } from '../components/mySearches';
import { pageSize } from '../actions/listings';
import { getCookie, setUserCookie } from '../components/cookies';
import { removeProperties, dateToISOShort, getUnFormattedPolygon, getSizes } from '../components/utils';
import EsriAutoComplete from '../components/esriautocomplete';
import Pagination from '../components/pagination';
import Footer from '../components/footer';
import SortOrder from '../components/sortOrder';
import LoginModal from '../components/LoginModal';

// begin libraries
import {
    Popover, PopoverBody,
    UncontrolledButtonDropdown, CustomInput,
    DropdownMenu, DropdownItem, DropdownToggle
} from 'reactstrap';
import qs from 'query-string';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
// using my own fork of buggyfill to include newer ipads
import * as viewportUnitsBuggyfill from 'viewport-units-buggyfill';

// begin scss
import '../scss/_dashboard.scss';
import '../scss/_listingCard.scss';
import '../scss/_searchFilters.scss';
import '../scss/_mapListings.scss';

// begin SVG
import arrowDown from '../images/icons/chevron-down.svg';
import arrowUp from '../images/icons/chevron-up.svg';
import EsriLeafletMap from '../components/esrileafletmap';
import toggleList from '../images/icons/toggle-list.svg';
import toggleTile from '../images/icons/toggle-tile.svg';
import map from '../images/icons/map.svg';
import mapActive from '../images/icons/map-active.svg';
import { ReactComponent as SingleMapIcon } from '../images/icons/single-map.svg';
import { ReactComponent as GalleryIcon } from '../images/icons/gallery.svg';
import LayerCard from '../components/LayersCard';

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wrapperHeight: window.innerHeight,
            listingContainerHeight: window.innerHeight,
            toggleView: 'tile',
            showMap: true,
            listingModal: false,
            propDetailsFilterOpen: false,
            featuresFilterOpen: false,
            propTypeFilterOpen: false,
            statusFilterOpen: false,
            currentPage: 0,
            locationText: '',
            filterText: 'More Filters',
            clearPolygon: false,
            underLandscapeTablet: false,
            showLoginModal: false,
            menuLayersOpen: false,
            layerSelected: null,
            mapAdd: null,
            poiSelected:{attraction: { featureType: 'poi.attraction', name: 'Attraction', enabled: false },
             business: { featureType: 'poi.business', name: 'Business', enabled: false },
             gov: { featureType: 'poi.government', name: 'Government', enabled: false },
             medical: { featureType: 'poi.medical', name: 'Medical', enabled: false },
             park: { featureType: 'poi.park', name: 'Park', enabled: true },
            worship: { featureType: 'poi.place_of_worship', name: 'Place of Worship', enabled: false },
            shcool: { featureType: 'poi.school', name: 'School', enabled: false },
            sports: { featureType: 'poi.sports_complex', name: 'Sports Complex', enabled: false }},
            popupOpen: false
        };
        this.pageSize = pageSize;
    }

    componentDidMount() {
        if(this.props.match.params?.listingID) {
            const listingID = this.props.match.params?.listingID;
            this.setState({ listingId: listingID, listingDetailsModal: true });
        }
        const { searchActions, searchFilters, publicPortal } = this.props;
        if (publicPortal) {
            searchActions.fetchPublicSearchConfig();
            searchActions.fetchPublicSearchSortOptions();
        } else {
            searchActions.fetchSearchConfig();
            searchActions.fetchSearchSortOptions();
        }

        if (this.props.match.params.filters) { // if refresh or link has search filters
            const filters = qs.parse(this.props.match.params.filters);
            filters.Criteria = JSON.parse(filters.Criteria);
            if (filters.Criteria.addresses && filters.Criteria.addresses.length)
                this.setState({ locationText: filters.Criteria.addresses[0] });
            if (filters.Criteria.cities && filters.Criteria.cities.length)
                this.setState({ locationText: filters.Criteria.cities[0] });
            if (filters.Criteria.zipCodes && filters.Criteria.zipCodes.length)
                this.setState({ locationText: filters.Criteria.zipCodes[0] })
            if (filters.Criteria.subdivisions && filters.Criteria.subdivisions.length)
                this.setState({ locationText: filters.Criteria.subdivisions[0] })
            searchActions.updateSearchFilters(filters);
        }
        // only do search if config is loaded already (returning to search) or they cleared them all
        else if (!searchFilters.Criteria.propertyType || searchFilters.Criteria.propertyType.length > 0)
            this.fetchSearch(this.props.searchFilters);

        if (this.props.location.openFilters) // clicked + New Search from my searches
            this.setState({ propDetailsFilterOpen: true });

        viewportUnitsBuggyfill.init();
        this.updateWindowDimensions();

        this.filtersTab = React.createRef();

        // load view mode form cookie
        if (this.props.myProfile) {
            const toggleView = getCookie('toggleView');
            if (toggleView && toggleView[this.props.myProfile.Id])
                this.setState({ toggleView: toggleView[this.props.myProfile.Id].toggleView, showMap: toggleView[this.props.myProfile.Id].showMap })

            if (!this.props.previousSearches) {
                this.props.searchActions.fetchMySearches(this.props.myProfile.Id);
            }
        }

        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.searchFilters) !== JSON.stringify(nextProps.searchFilters)) {
            this.setState({ currentPage: 0 });
            if ((nextProps.searchFilters.locationText === undefined ||
                nextProps.searchFilters.locationText === null) && this.state.locationText !== "") {
                this.setState({ locationText: "" });
                if (this.esriAutoComplete && this.esriAutoComplete.clear) {
                    this.esriAutoComplete.clear();
                }
            }
            else if (nextProps.searchFilters.locationText !== undefined &&
                nextProps.searchFilters.locationText !== null &&
                nextProps.searchFilters.locationText !== this.state.locationText) {
                this.setState({ locationText: nextProps.searchFilters.locationText ? nextProps.searchFilters.locationText : "" });
            }
            // waiting for DefaultOptions from searchConfig or they cleared them all which is valid
            if (!nextProps.searchFilters.Criteria.propertyType || nextProps.searchFilters.Criteria.propertyType.length > 0)
                this.fetchSearch(nextProps.searchFilters);
        }
        // searchConfig loaded and they don't already have propertyTypes selected or cleared so use default
        else if (JSON.stringify(this.props.searchConfig) !== JSON.stringify(nextProps.searchConfig) &&
            (this.props.searchFilters.Criteria.propertyType && this.props.searchFilters.Criteria.propertyType.length === 0)) {
            const { PropertyType: propertyType } = nextProps.searchConfig;
            this.props.searchActions.updateSearchFilters({
                Criteria: { ...this.props.searchFilters.Criteria, propertyType: propertyType.DefaultOptions }
            });
        }
        else if (this.props.myProfile !== nextProps.myProfile) {
            const toggleView = getCookie('toggleView');
            if (toggleView && toggleView[nextProps.myProfile.Id])
                this.setState({ toggleView: toggleView[nextProps.myProfile.Id].toggleView, showMap: toggleView[nextProps.myProfile.Id].showMap })

            this.props.searchActions.fetchMySearches(nextProps.myProfile.Id);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { publicPortal } = this.props;
        if (this.state.scrollMapResults) {
            this.searchContainer.scrollIntoView({ block: 'start' });
            this.setState({ scrollMapResults: false });
        }

        if (this.state.propDetailsFilterOpen !== prevState.propDetailsFilterOpen) {
            // closing filters box and criteria changed, mark as current and save
            if (!this.state.propDetailsFilterOpen && JSON.stringify(this.state.prevSearch) !== JSON.stringify(this.props.searchFilters)) {
                this.setState({ prevSearch: this.props.searchFilters });
                /**
                * Do not save previous search if it is a public portal
                */
                if (!publicPortal) this.props.searchActions.savePrevious(this.props.searchFilters);
            }
        }
    }

    updateWindowDimensions = () => {
        const { underLandscapeTablet } = getSizes();
        this.setState({ underLandscapeTablet }, () => { this.updateDropdownTitle() });
        const wrapperHeight = underLandscapeTablet ? (window.innerHeight - 90) + 'px' : (window.innerHeight - 109) + 'px';
        const listingContainerHeight = (window.innerHeight - 166) + 'px';//''calc(100vh - 166px)';
        this.setState({ wrapperHeight, listingContainerHeight });
        viewportUnitsBuggyfill.refresh();
    }

    onLocationTextChange = (event) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        if (event === "" && searchFilters.cities !== undefined && searchFilters.cities !== null && searchFilters.cities.length > 0) {
            delete searchFilters["cities"];
            this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
        }
        else if(event === "" && searchFilters.addresses !== undefined && searchFilters.addresses !== null && searchFilters.addresses.length > 0) {
            delete searchFilters["addresses"];
            this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
        }
        else if (event === "" && searchFilters.zipCodes !== undefined && searchFilters.zipCodes !== null && searchFilters.zipCodes.length > 0) {
            delete searchFilters["zipCodes"];
            this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
        }
        else if (event === "" && searchFilters.subdivisions !== undefined && searchFilters.subdivisions !== null && searchFilters.subdivisions.length > 0) {
            delete searchFilters["subdivisions"];
            this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
        }
        this.setState({ locationText: event });
    }

    onListingHover = (listing) => {
        this.setState({ bounceListingId: listing.Id })
    }

    onMultiSelectChange = (inputValue, { action, name }) => {
        const { Criteria } = this.props.searchFilters;
        const { [name]: currentFilter, ...restCriteria } = Criteria;
        this.props.searchActions.updateSearchFilters({
            Criteria: {
                ...restCriteria,
                ...(inputValue) && { [name]: inputValue.map(i => i.value) }
            }
        });
    }

    fetchSearch = (filters, page) => {
        const { location, searchActions, publicPortal, listingActions } = this.props;
        const { fetchPublicSearch, fetchSearch } = listingActions
        this.updateQueryString(filters);
        const isSavedSearch = location.isSavedSearch || this.state.isSavedSearch;
        // first time or loading saved/prev search, mark as current
        if (!this.state.prevSearch || isSavedSearch) {
            this.setState({ prevSearch: filters, isSavedSearch: false });
        }
        // they've changed cities or price (more filters is closed and criteria changed). mark as current and save
        else if (!this.state.propDetailsFilterOpen && (JSON.stringify(this.state.prevSearch) !== JSON.stringify(filters))) {
            this.setState({ prevSearch: filters });
            /**
             * Do not save previous search if it is a public portal
             */
            if (!publicPortal) searchActions.savePrevious(filters);
        }

        return publicPortal ? fetchPublicSearch(filters, page) : fetchSearch(filters, page);
    }

    updateQueryString = (filters) => {
        const { history, publicPortal } = this.props;
        history.push(publicPortal ? `/search/public/${buildSearchQueryString(filters)}` : `/search/${buildSearchQueryString(filters)}`);
    }

    toggleModal = (key, save) => {
        this.setState({ [key]: !this.state[key] })
    }

    toggleView = (toggleView, showMap) => {
        const { myProfile } = this.props;
        showMap = (typeof showMap !== 'undefined') ? showMap : this.state.showMap;
        toggleView = toggleView || this.state.toggleView;
        this.setState({ toggleView: toggleView, showMap: showMap });
        setUserCookie(myProfile.Id, 'toggleView', { toggleView: toggleView, showMap: showMap });
    }

    toggleFilterDropdown = () => {
        this.setState({
            propDetailsFilterOpen: !this.state.propDetailsFilterOpen,
        }, () => { this.updateDropdownTitle() });
        window.scrollTo(0, 0);
    }

    updateDropdownTitle = () => {
        if (this.state.underLandscapeTablet) {
            this.setState({
                filterText: this.state.propDetailsFilterOpen ? 'Hide Filters' : 'Show Filters'
            });
        } else {
            this.setState({
                filterText: this.state.propDetailsFilterOpen ? 'Fewer Filters' : 'More Filters'
            });
        }
    };

    buildModal = (key) => {
        switch (key) {
            case 'listingModal':
                return <ListingModal onContactAgent={() => this.toggleLoginModal()} publicPortal={this.props.publicPortal} settings={this.props.settings} listingActions={this.props.listingActions} listingId={this.state.listingId} modalIsOpen={this.state[key]} toggle={this.toggleModal} showNotification={this.props.showNotification}></ListingModal>
            case 'listingDetailsModal':
                return <ListingDetailsModal publicPortal={this.props.publicPortal} settings={this.props.settings} history={this.props.history} listingActions={this.props.listingActions} listingId={this.state.listingId} modalIsOpen={this.state[key]} toggle={this.toggleModal}></ListingDetailsModal>
            default:
                return null;
        }
    }

    handleAutoCompleteBlur = (e) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        this.setState({ locationText: "" });
        if (this.esriAutoComplete && this.esriAutoComplete.clear) {
            this.esriAutoComplete.clear();
        }
        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
        this.fetchSearch(this.props.searchFilters);
    }

    handleAutoComplete = (obj) => {
        if (obj) {
            let searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
            if (obj.length > 0 && obj[0].key && obj[0].key !== "") {

                //handle cities
                if (obj[0].header === 'City') {
                    let cities = searchFilters.cities ? [...searchFilters.cities, obj[0].key] : [obj[0].key];
                    const uniqueCities = Array.from(new Set(cities));
                    delete searchFilters['cities'];
                    searchFilters['cities'] = uniqueCities;
                }

                //handle Addresses
                else if (obj[0].header === 'Address') {
                    let addresses = searchFilters.addresses ? [...searchFilters.addresses, obj[0].key] : [obj[0].key];
                    const uniqueAddresses = Array.from(new Set(addresses));
                    delete searchFilters['addresses'];
                    searchFilters['addresses'] = uniqueAddresses;
                }

                //handle zip codes
                else if (obj[0].header === 'Zip Code') {
                    let zipCodes = searchFilters.zipCodes ? [...searchFilters.zipCodes, obj[0].key] : [obj[0].key];
                    const uniqueZipCodes = Array.from(new Set(zipCodes));
                    delete searchFilters['zipCodes'];
                    searchFilters['zipCodes'] = uniqueZipCodes;
                }

                //handle subdivisions
                else if (obj[0].header === 'Subdivision') {
                    let subdivisions = searchFilters.subdivisions ? [...searchFilters.subdivisions, obj[0].key] : [obj[0].key];
                    const uniqueSubdivisions = Array.from(new Set(subdivisions));
                    delete searchFilters['subdivisions'];
                    searchFilters['subdivisions'] = uniqueSubdivisions;
                }

                delete searchFilters['mapbound'];
                this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
            }
        }
    }

    handlePageChange = (e, index) => {
        e.preventDefault();
        if (this.state.showMap && !this.props.listings.pages[index + 1]) // try to wait till listings load, kind of working
            this.fetchSearch(this.props.searchFilters, index + 1).then(() => {
                this.setState({
                    currentPage: index,
                    scrollMapResults: true
                });
            });
        else {
            if (!this.props.listings.pages[index + 1])
                this.fetchSearch(this.props.searchFilters, index + 1);
            this.setState({ currentPage: index });
            window.scrollTo(0, 0);
        }
    }

    handleFilterChange = (name, value, type) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);

        if (!value || value === '' || ['No max', 'No min'].includes(value))
            delete searchFilters[name];
        else
            this.setFilterObjVal(searchFilters, name, value, type || '')

        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
    }

    handleInputChange = debounce((e) => {
        this.handleFilterChange('keywords', e.target.value, 'keywords');
    }, 500)

    setFilterObjVal = (searchFilters, name, value, type) => {
        switch (type) {
            case 'int':
                searchFilters[name] = parseInt(value, 10);
                break;
            case 'bool':
                searchFilters[name] =
                    (value.toLowerCase() === "true" || value.toLowerCase() === "yes") ? true : false;
                break;
            case 'str':
                searchFilters[name] = value;
                break;
            case 'keywords':
                searchFilters[name] = value.split(",");
                break;
            default:
                searchFilters[name] = value;
        }
    }


    handleCheckBoxRadioChange = (event, valType) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        if (event.target.type === "radio") {
            if (event.target.value === "")
                delete searchFilters[event.target.name];
            else
                this.setFilterObjVal(searchFilters, event.target.name, event.target.value, valType);
        }
        else {
            delete searchFilters[event.target.name];
            if (event.target.type === "checkbox" && event.target.checked) searchFilters[event.target.name] = true;
            if (event.target.type === "checkbox") {
                if (event.target.name === "includeOpenHouse") {
                    if (event.target.checked) {
                        const dtFrom = new Date();
                        const dtTo = new Date();
                        dtTo.setDate(dtFrom.getDate() + 7);
                        searchFilters.minOpenHouseDate = dateToISOShort(dtFrom);
                        searchFilters.maxOpenHouseDate = dateToISOShort(dtTo);
                    }
                    else {
                        delete searchFilters["minOpenHouseDate"];
                        delete searchFilters["maxOpenHouseDate"];
                    }
                }
            }
        }

        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
    }

    handleSaleOrLeaseChange = (event) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        searchFilters.forSale = false;
        searchFilters.forRent = false;
        searchFilters[event.target.value] = true;
        delete searchFilters["minForSale"];
        delete searchFilters["maxForSale"];
        delete searchFilters["minRent"];
        delete searchFilters["maxRent"];
        delete searchFilters["minCommercial"];
        delete searchFilters["maxCommercial"];
        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
    }

    handleSortOrderChange = (key, val) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        searchFilters.sortOrder = val;
        this.props.searchActions.updateSearchFilters(Object.assign({}, this.props.searchFilters, { Criteria: searchFilters }));
    }

    getDDFilterOptions = (searchConfig, name, parent, type) => {
        const Lst = [];
        let obj = null;
        if (searchConfig) {
            if (parent && searchConfig[parent] && searchConfig[parent].length > 0) {
                const objLst = searchConfig[parent].filter(e => e.Id === name);
                if (objLst && objLst.length > 0) {
                    obj = objLst[0];
                }
            }
            else {
                obj = searchConfig[name];
            }
        }
        if (obj && obj.Options && obj.Options.length > 0 && obj.Id && obj.Id !== "") {
            Lst.push(obj.Options.map((item, i) => {
                return (
                    <DropdownItem key={i} onClick={() => { this.handleFilterChange(obj.Id, item, type); }}>{item}</DropdownItem>
                )
            }));
        }
        if (Lst.length > 0) return (<DropdownMenu>{Lst}</DropdownMenu>);

        return null;
    }

    getSingleSelectCheckBoxList = (list, name, postfix, valType) => {
        const Lst = [];
        if (list && list.length > 0) {
            let cls = "sm";
            if (list.length <= 4) {
                cls = "size" + (parseInt((100 / list.length), 10));
            }
            Lst.push(list.map((item, i) => {
                return (
                    <CustomInput key={i} type="radio" id={item === "" ? "radAny_" + name : "rad" + item + "_" + name} inline className={"icon_checkbox " + cls}
                        name={name} value={item}
                        checked={this.isChecked(name, item, valType)}
                        onChange={(e) => this.handleCheckBoxRadioChange(e, valType)}
                        onFocus={(e) => e.currentTarget.parentElement.classList.add('with-focus')}
                        onBlur={(e) => e.currentTarget.parentElement.classList.remove('with-focus')}
                        label={(
                            <div className="icon_checkbox_wrapper">
                                <div className="chk_label">{item === "" ? "Any" : (item + postfix)}</div>
                            </div>
                        )}
                    />
                )
            }));
        }
        if (Lst.length > 0) return (<div className="icon_checkbox_list">{Lst}</div>);

        return null;
    }

    isChecked = (name, val, valType) => {
        const searchFilters = Object.assign({}, this.props.searchFilters.Criteria);
        let returnVal = false;
        if (val === "" && (searchFilters[name] === undefined || searchFilters[name] === null || searchFilters[name] === "")) {
            returnVal = true;
        }
        else {
            if (valType === "int") {
                returnVal = (searchFilters[name] !== undefined && searchFilters[name] !== null && searchFilters[name] !== "") ? (parseInt(searchFilters[name], 10) === parseInt(val, 10)) : false;
            }
            else if (valType === "bool") {
                returnVal = (searchFilters[name] !== undefined && searchFilters[name] !== null && ((searchFilters[name] === true && (val.toLowerCase() === "true" || val.toLowerCase() === "yes")) || (searchFilters[name] === false && (val.toLowerCase() === "false" || val.toLowerCase() === "no")))) ? true : false;
            }
            else if (valType === "str") {
                returnVal = (searchFilters[name] !== undefined && searchFilters[name] !== null && searchFilters[name] !== "" && val !== "") ? (searchFilters[name].indexOf(val) > -1) : false;
            }
        }

        return returnVal;
    }

    showHideDropdown = (underLandscapeTablet, searchFilters, isCommercial) => {
        if (!underLandscapeTablet) {
            const action = isCommercial ? this.commercialDropdowns() : this.forSaleDropdowns();
            return <>
                {searchFilters.Criteria.forRent ? this.forRentDropdowns() : action}
                {this.bedsBathsDropdowns()}
            </>
        }
    }

    commercialDropdowns = () => <Fragment>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.minCommercial && this.props.searchFilters.Criteria.minCommercial !== "") ?
                    this.props.searchFilters.Criteria.minCommercial : "Min Price"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'minCommercial', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
        <span className="price-filter-divider"> - </span>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.maxCommercial && this.props.searchFilters.Criteria.maxCommercial !== "") ?
                    this.props.searchFilters.Criteria.maxCommercial : "Max Price"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'maxCommercial', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
    </Fragment>

    forSaleDropdowns = () => <Fragment>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.minForSale && this.props.searchFilters.Criteria.minForSale !== "") ?
                    this.props.searchFilters.Criteria.minForSale : "Min Price"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'minForSale', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
        <span className="price-filter-divider"> - </span>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.maxForSale && this.props.searchFilters.Criteria.maxForSale !== "") ?
                    this.props.searchFilters.Criteria.maxForSale : "Max Price"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'maxForSale', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
    </Fragment>;

    forRentDropdowns = () => <Fragment>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.minRent && this.props.searchFilters.Criteria.minRent !== "") ?
                    this.props.searchFilters.Criteria.minRent : "Min Rent"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'minRent', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
        <span className="price-filter-divider"> - </span>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown open', { "with-cities": this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.maxRent && this.props.searchFilters.Criteria.maxRent !== "") ?
                    this.props.searchFilters.Criteria.maxRent : "Max Rent"}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            {this.getDDFilterOptions(this.props.searchConfig, 'maxRent', 'PropertyDetails')}
        </UncontrolledButtonDropdown>
    </Fragment>;

    bedsBathsDropdowns = () => <Fragment>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown mg-lft-12 open', { 'with-cities': this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.minBeds && this.props.searchFilters.Criteria.minBeds !== "") ?
                    this.props.searchFilters.Criteria.minBeds + '+ Beds' : 'Min Beds'}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            <DropdownMenu>
                {['No min', '1', '2', '3', '4', '5', '6'].map((num, i) =>
                    <DropdownItem key={i} onClick={() => { this.handleFilterChange('minBeds', num, 'int'); }}>{num}</DropdownItem>
                )}
            </DropdownMenu>
        </UncontrolledButtonDropdown>
        <UncontrolledButtonDropdown className={classNames('dyna-dropdown mg-lft-12 open', { 'with-cities': this.props.searchFilters.Criteria.cities })}>
            <DropdownToggle caret size="sm">
                <span>{(this.props.searchFilters.Criteria && this.props.searchFilters.Criteria.minBaths && this.props.searchFilters.Criteria.minBaths !== "") ?
                    this.props.searchFilters.Criteria.minBaths + '+ Baths' : 'Min Baths'}
                </span>
                <img src={arrowDown} alt="arrowd" className="mg-lft-auto" />
            </DropdownToggle>
            <DropdownMenu>
                {['No min', '1', '2', '3', '4', '5', '6'].map((num, i) =>
                    <DropdownItem key={i} onClick={() => { this.handleFilterChange('minBaths', num, 'int'); }}>{num}</DropdownItem>
                )}
            </DropdownMenu>
        </UncontrolledButtonDropdown>
    </Fragment>;

    toggleLoginModal = () => {
        this.setState( {
            showLoginModal: !this.state.showLoginModal,
        });
    }


    render() {
        const { listings, listingDetails, searchFilters, searchConfig, sortOptions, previousSearches, savedSearches, propertyType, mustHaves, publicPortal, history } = this.props;
        const { isMobile, underLandscapeTablet, under1200 } = getSizes();
        const { currentPage, wrapperHeight, showMap, toggleView, menuLayersOpen, layerSelected, mapAdd, poiSelected, popupOpen } = this.state;
        const all_layers = JSON.parse(process.env.REACT_APP_Map_Layers || []);

        const selectPoi = (k,v) => {
          //poiSelected[k].enabled = v;
          this.setState(prevState => ({
            poiSelected: {
              ...prevState.poiSelected,
              [k] :{
                ...prevState.poiSelected[k],
                enabled: v
              }
            }
          }));
        };

        if (listings === undefined || listings.ids === undefined || listingDetails === undefined)
            return (<div></div>)

        // If the width is under 1200px, switch from list view to tile view if map is visable
        if (under1200 && showMap && toggleView === 'list') {
            this.toggleView('tile');
        }

        const listingContainer = showMap ? {
            overflowY: toggleView === 'list' ? 'hidden' : 'auto',
            overflowX: toggleView === 'list' ? 'unset' : 'hidden'
        } : {
            overflow: toggleView === 'tile' ? 'auto' : 'unset'
        }
        const rightWrapperClass = classNames('rightWrapper', { 'show-map': showMap, 'popup-open':  popupOpen });
        const leftWrapperClass = classNames('leftWrapper', { 'show-map': showMap, 'popup-open':  popupOpen });
        const tileClass = classNames("row mg-rt-0 mg-lft-0", { "mg-btm-47": !showMap })
        const listClass = classNames({ "row search-container mg-rt-0 mg-lft-0": showMap, "container-fluid mg-btm-47": !showMap })
        const paginationWrapper = classNames(
            'pagination_wrapper', {
            'show-map': showMap,
            'full-screen': !showMap,
            'fixed-pager': !showMap
        });

        let from = this.paginationRef ? this.paginationRef.getFrom(currentPage) : 0;
        const to = this.paginationRef ? this.paginationRef.getTo(from, listings.totalCount) : 0;
        if (to === 0)
            from = 0;

        const mapListings = listings.pages[this.state.currentPage + 1] ? listings.pages[this.state.currentPage + 1].map((id, i) => {
            return { ...listingDetails[id] };
        }) : [];

        const isCommercial = searchFilters.Criteria && searchFilters.Criteria.propertyType && searchFilters.Criteria.propertyType.length === 1 && searchFilters.Criteria.propertyType.indexOf('Commercial') !== -1;

        //we do not want filters for location or price to contribute to the filter count
        const uncountedFilters = ['cities', 'forRent', 'forSale', 'mapbound', 'status', 'subdivisions', 'zipCodes', 'polygon', 'minForSale', 'maxForSale', 'minRent', 'maxRent', 'minCommercial', 'maxCommercial'];
        let filterCount = Object.keys(searchFilters.Criteria).filter(f => !uncountedFilters.includes(f)).length;
        //we want to count forRent as a filter only when true but not forSale because it is the default
        if (searchFilters.Criteria.forRent)
            filterCount++;

        //we only want to count status if it is set to something other than Active, which is the default
        //additionally, we don't want to count status if forRent is true
        if (searchFilters.Criteria.status !== 'Active' && !searchFilters.Criteria.forRent)
            filterCount++;

        return (
            <div>
                <div className={classNames('dyna-search-filter-bar navbar fixed-top', { 'with-cities': searchFilters.Criteria.cities })}>
                    <div className="dyna-search-filter-bar_left pd-lft-0">
                        <h1 className="dyna-hidden">Search</h1>
                        <div className="dyna-form" style={{ width: '99%' }}>
                            <div className="input-group">
                                <EsriAutoComplete
                                    ref={ref => this.esriAutoComplete = ref}
                                    className="search full-width"
                                    placeholder="Enter City, Zip Code, Neighborhood/Subdivision, Address"
                                    hideFocus={true}
                                    defaultSelected={this.state.locationText}
                                    defaultPropertyTypes={(searchConfig.PropertyType || {}).DefaultOptions}
                                    handleAutoComplete={this.handleAutoComplete}
                                    onInputChange={this.onLocationTextChange}
                                    onBlur={this.handleAutoCompleteBlur}
                                    handlePolygonClear={() => this.setState({ clearPolygon: true })}
                                    usePublicFetch={publicPortal}
                                    showHideFilterButton={!publicPortal}
                                    onClearFilters={() => {
                                        if (this.esriLeafletMap) {
                                            this.esriLeafletMap.resetMap()
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="dyna-search-filter-bar_right pd-rt-0 pd-lft-0 txt-algn-rt">
                        <div className="price-filter-container">
                            {this.showHideDropdown(underLandscapeTablet, searchFilters, isCommercial)}
                            <div className={classNames('d-flex', { 'mg-lft-auto ': !underLandscapeTablet })}>
                                <button id="propDetailsFilter" className={classNames('search-btn mg-lft-12', { 'active': this.state.propDetailsFilterOpen })}
                                    onClick={() => {
                                        this.toggleFilterDropdown('propDetailsFilterOpen');
                                        setTimeout(() => {
                                            if (this.filtersTab.current) {
                                                return this.filtersTab.current.focus();
                                            }
                                            return null;
                                        }, 500);
                                    }}>
                                    {this.state.filterText}
                                    <span className="filter-count">({filterCount})</span>
                                    <img src={this.state.propDetailsFilterOpen ? arrowUp : arrowDown} alt="arrowd" />
                                </button>
                                <SavedSearchModal
                                    search={{ criteria: this.props.searchFilters.Criteria }}
                                    savedSearchNames={savedSearches ? savedSearches.map(x => x.searchName) : []}
                                    savedSearchesCount={(savedSearches || []).length}
                                    isSaveSearchBtn
                                />
                                <span id="fakeButtonPlaceholder" aria-hidden></span>
                            </div>
                        </div>
                        <div className="display-ib">
                            <Popover fade={false} placement="bottom-end" isOpen={this.state.propDetailsFilterOpen}
                                target="fakeButtonPlaceholder"
                                className={classNames("searchFiltersPopOver savedSearchesFilter", { "with-cities": this.props.searchFilters.Criteria.cities })}>
                                <PopoverBody>
                                    <div className="dyna-popoverBody more-filters">
                                        <div className="my-searches-container">
                                            <MySearches
                                                {...this.props}
                                                setRef={this.filtersTab}
                                                previousSearches={previousSearches}
                                                savedSearches={savedSearches}
                                                loadSearch={(search) => {
                                                    this.setState({ isSavedSearch: true }, () => {
                                                        this.props.searchActions.updateSearchFilters({ ...removeProperties(search, "criteria"), Criteria: search.criteria });
                                                    });
                                                    this.toggleModal('propDetailsFilterOpen');
                                                }}
                                                // begin search filters props
                                                listings={listings}
                                                searchFilters={searchFilters}
                                                searchConfig={searchConfig}
                                                propertyType={propertyType}
                                                mustHaves={mustHaves}
                                                onMultiSelectChange={this.onMultiSelectChange}
                                                handleInputChange={this.handleInputChange}
                                                handleSaleOrLeaseChange={this.handleSaleOrLeaseChange}
                                                handleCheckBoxRadioChange={this.handleCheckBoxRadioChange}
                                                getDDFilterOptions={this.getDDFilterOptions}
                                                getSingleSelectCheckBoxList={this.getSingleSelectCheckBoxList}
                                            />
                                        </div>
                                    </div>
                                </PopoverBody>
                            </Popover>
                        </div>
                    </div>
                </div>
                <div className={classNames('mainWrapper mainWrapper_search', { 'with-cities': this.props.searchFilters.Criteria.cities })}>
                    <div className="btn-toggle-map-mobile">
                        {showMap &&
                            <div onClick={() => this.setState({ showMap: !this.state.showMap }, () => window.scrollTo(0, 0))}>
                                <GalleryIcon />
                            </div>
                        }
                        {!showMap &&
                            <div onClick={() => this.setState({ showMap: !this.state.showMap }, () => window.scrollTo(0, 0))}>
                                <SingleMapIcon />
                            </div>
                        }
                    </div>
                    <div className={leftWrapperClass} tabIndex="-1">
                        <EsriLeafletMap
                            ref={ref => this.esriLeafletMap = ref}
                            properties={mapListings}
                            resultsCount={mapListings.length}
                            height={wrapperHeight}
                            history={this.props.history}
                            allowMapBoundUpdate={true}
                            allowDraw={true}
                            allowLocate={true}
                            allowLayers={true}
                            polygon={(searchFilters && searchFilters.Criteria && searchFilters.Criteria.polygon && this.props.searchFilters.Criteria.polygon !== "")
                                ? getUnFormattedPolygon(searchFilters.Criteria.polygon) : []}
                            onCommentsClick={(id) => {
                                const listingModalName = publicPortal ? 'listingDetailsModal' : 'listingModal';
                                this.setState({ listingId: id }, () => this.toggleModal(listingModalName));
                            }}
                            bounceMarker={this.state.bounceListingId}
                            clearPolygon={this.state.clearPolygon}
                            onPolygonCleared={() => this.setState({ clearPolygon: false })}
                            openMenuLayers={() => this.setState({ menuLayersOpen: true })}
                            layers={all_layers}
                            mapAdd={mapAdd}
                            setMapAdd={(map) => this.setState({ mapAdd: map })}
                            layerSelected={layerSelected}
                            poiSelected={poiSelected}
                            onPopupOpen={() => this.setState({popupOpen: true})}
                            onPopupClose={() => this.setState({popupOpen: false})}
                        />
                        <LayerCard
                            layers={all_layers}
                            open={menuLayersOpen}
                            onClose={() => this.setState({ menuLayersOpen: false })}
                            layerSelected={layerSelected}
                            setlayerSelected={(layerSelected) => this.setState({ layerSelected })}
                            poiSelected={poiSelected}
                            setPoiSelected={selectPoi}
                        />
                    </div>
                    <div className={rightWrapperClass}>
                        <div className="row search-fiters mg-rt-0 mg-lft-0" style={{ padding: '13px 15px' }}>
                            <div className="listings-count">{`${listings.totalCount} Results`}</div>
                            <div className="d-inline-flex mg-lft-auto">
                                <SortOrder
                                    sortOptions={sortOptions}
                                    sortOrder={(searchFilters.Criteria && searchFilters.Criteria.sortOrder) || "Newest"}
                                    isMobile={isMobile}
                                    onChange={this.handleSortOrderChange}
                                    id={'sortOptionsPopover'}
                                />
                                <div className="pd-lft-5" style={{ cursor: "pointer", display: "inline-block" }}>
                                    {toggleView === 'list' &&
                                        <img src={toggleList} className="d-none d-md-inline-block"
                                            onClick={() => this.toggleView('tile')}
                                            onKeyPress={(e) => { if (e.key === 'Enter') this.toggleView('tile') }}
                                            alt="list-view" role="button" tabIndex="0" />
                                    }
                                    {toggleView === 'tile' && (!under1200 || !showMap) &&
                                        <img src={toggleTile} className="d-none d-md-inline-block"
                                            onClick={() => this.toggleView('list')}
                                            onKeyPress={(e) => { if (e.key === 'Enter') this.toggleView('list') }}
                                            alt="tile-view" role="button" tabIndex="0" />
                                    }
                                    <img src={showMap ? mapActive : map} alt="map" className="pd-lft-5"
                                        onClick={() => this.toggleView(null, !showMap)}
                                        onKeyPress={(e) => { if (e.key === 'Enter') this.toggleView(null, !showMap) }}
                                        role="button" tabIndex="0" />
                                </div>
                            </div>
                        </div>
                        <div className={toggleView === 'list' ? "" : null} id="listing-container" style={listingContainer}>
                            {toggleView === 'tile' &&
                                <>
                                    <div ref={el => (this.searchContainer = el)} className={tileClass}>
                                        {listings.pages[this.state.currentPage + 1] && listings.pages[this.state.currentPage + 1].map((id, i) => {
                                            return (
                                                <div key={i} onMouseEnter={() => this.onListingHover(listingDetails[id])} onMouseLeave={() => this.setState({ bounceListingId: null })} className={`${showMap ? "col-xl-6" : "col-sm-6 col-lg-4 col-xl-3"} pd-sides-8`}>
                                                    <ListingCard
                                                        publicPortal={publicPortal}
                                                        history={history}
                                                        listingActions={this.props.listingActions}
                                                        listing={listingDetails[id]}
                                                        showMap={showMap}
                                                        onCommentsClick={() => { this.setState({ listingId: id }, () => this.toggleModal('listingModal')) }}
                                                        onClick={() => { this.setState({ listingId: id }, () => this.toggleModal('listingDetailsModal')) }}>
                                                    </ListingCard>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className={classNames('row mg-rt-0 mg-lft-0', { 'mg-btm-47': showMap, 'mg-btm-50': !showMap })}>
                                        <div className="col">
                                            <Footer settings={this.props.settings} />
                                        </div>
                                    </div>
                                </>
                            }
                            {toggleView === 'list' &&
                                <div ref={el => (this.searchContainer = el)} className={listClass}>
                                    <div className={showMap ? "col-md-12 p-0" : "col-md-12 col-lg-8 offset-lg-2"}>
                                        <ListViewTable
                                            publicPortal={publicPortal}
                                            history={history}
                                            onMouseEnter={(listing) => this.onListingHover(listing)}
                                            onMouseLeave={() => this.setState({ bounceListingId: null })}
                                            underLandscapeTablet={underLandscapeTablet}
                                            listingActions={this.props.listingActions}
                                            listingIds={listings.pages[this.state.currentPage + 1]}
                                            listingDetails={listingDetails}
                                            showMap={showMap} isListView={true}
                                            onCommentsClick={(id) => { this.setState({ listingId: id }, () => this.toggleModal('listingModal')) }}
                                            onClick={(id) => { this.setState({ listingId: id }, () => this.toggleModal('listingDetailsModal')) }}
                                            settings={this.props.settings}>
                                        </ListViewTable>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={paginationWrapper}>
                            <div className="pagination_search">
                                <div className="sorting_resultsnumber ft-sz-13">
                                    <span className="ft-bold">{`${from}-${to}`}</span> of {listings.totalCount}
                                </div>
                                <Pagination ref={ref => this.paginationRef = ref}
                                    currentPage={currentPage}
                                    totalCount={listings.totalCount}
                                    pageSize={this.pageSize}
                                    handlePageChange={this.handlePageChange}>
                                </Pagination>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.listingModal &&
                    this.buildModal('listingModal')
                }
                {this.state.listingDetailsModal &&
                    this.buildModal('listingDetailsModal')
                }
            <LoginModal {...this.props} open={this.state.showLoginModal} onClose={() => this.toggleLoginModal()}></LoginModal>
            </div>
        );
    }
};

const mapStateToProps = (state, props) => ({
    listingDetails: state.entities.Listings,
    listings: state.listings.search || { ids: [], pages: [], totalCount: 0 },
    searchFilters: (state.search && state.search.filters) || {},
    searchConfig: (state.search && state.search.searchConfig) || {},
    sortOptions: (state.search && state.search.sortOptions) || ["Newest"],
    savedSearches: state.search && state.search.savedSearches,
    previousSearches: state.search && state.search.previousSearches,
    myProfile: state.profile.mine,
    settings: state.profile.settings || {},
    propertyType: state.search.searchConfig.PropertyType || { Options: [] },
    mustHaves: state.search.searchConfig.MustHaves || []
});

const mapDispatchToProps = dispatch => ({
    listingActions: bindActionCreators(listingActions, dispatch),
    searchActions: bindActionCreators(searchActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);


export const buildSearchQueryString = (filters) => {
    let query = qs.stringify({
        Criteria: JSON.stringify({
            includeOpenHouse: filters.Criteria.includeOpenHouse,
            maxHOA: filters.Criteria.maxHOA,
            maxLotSize: filters.Criteria.maxLotSize,
            maxOpenHouseDate: filters.Criteria.maxOpenHouseDate,
            maxSqft: filters.Criteria.maxSqft,
            maxYearBuilt: filters.Criteria.maxYearBuilt,
            minBaths: filters.Criteria.minBaths,
            minBeds: filters.Criteria.minBeds,
            minLotSize: filters.Criteria.minLotSize,
            minOpenHouseDate: filters.Criteria.minOpenHouseDate,
            minSqft: filters.Criteria.minSqft,
            minYearBuilt: filters.Criteria.minYearBuilt,
            // minClosedDate: filters.Criteria.minClosedDate ? formatDate(filters.Criteria.minClosedDate) : undefined,
            // maxClosedDate: filters.Criteria.maxClosedDate ? formatDate(filters.Criteria.maxClosedDate) : undefined,
            minClosedDate: filters.Criteria.minClosedDate,
            maxClosedDate: filters.Criteria.maxClosedDate,
            propertyType: filters.Criteria.propertyType,
            status: filters.Criteria.status,
            maxSearchPrice: filters.Criteria.maxSearchPrice,
            minSearchPrice: filters.Criteria.minSearchPrice,
            minRent: filters.Criteria.minRent,
            maxRent: filters.Criteria.maxRent,
            minForSale: filters.Criteria.minForSale,
            maxForSale: filters.Criteria.maxForSale,
            minCommercial: filters.Criteria.minCommercial,
            maxCommercial: filters.Criteria.maxCommercial,
            minParkingSpaces: filters.Criteria.minParkingSpaces,
            minGarageSpaces: filters.Criteria.minGarageSpaces,
            hasPool: filters.Criteria.hasPool,
            mustHaveView: filters.Criteria.mustHaveView,
            stories: filters.Criteria.stories,
            keywords: filters.Criteria.keywords,
            cities: filters.Criteria.cities,
            zipCodes: filters.Criteria.zipCodes,
            subdivisions: filters.Criteria.subdivisions,
            mapbound: filters.Criteria.mapbound,
            forRent: filters.Criteria.forRent,
            forSale: filters.Criteria.forSale,
            sortOrder: filters.Criteria.sortOrder,
            minParkingGarageSpaces: filters.Criteria.minParkingGarageSpaces,
            mustHaveWaterfrontView: filters.Criteria.mustHaveWaterfrontView,
            polygon: filters.Criteria.polygon,
            mustHaveBasement: filters.Criteria.mustHaveBasement,
            mustHaveParkingSpaces: filters.Criteria.mustHaveParkingSpaces,
            mustHaveAdditionalLivingQuarters: filters.Criteria.mustHaveAdditionalLivingQuarters
        })
    });
    return query;
}
